import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { HomeIcon, CalendarIcon, MessageCircleIcon, BookmarkIcon, MoreHorizontalIcon } from 'lucide-react';
// Pages
import Home from './pages/Home';
import Bookings from './pages/Bookings';
import Activities from './pages/Activities';
import Assistant from './pages/Assistant';
import Facilities from './pages/Facilities';
import More from './pages/More';
import Maintenance from './pages/Maintenance';
import Weather from './pages/Weather';
import Map from './pages/Map';
import Contact from './pages/Contact';
import Feedback from './pages/Feedback';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col h-screen bg-gray-50" data-id="element-1">
        <div className="flex-1 overflow-y-auto pb-16" data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
            <Route path="/bookings" element={<Bookings data-id="element-7" />} data-id="element-6" />
            <Route path="/activities" element={<Activities data-id="element-9" />} data-id="element-8" />
            <Route path="/assistant" element={<Assistant data-id="element-11" />} data-id="element-10" />
            <Route path="/facilities" element={<Facilities data-id="element-13" />} data-id="element-12" />
            <Route path="/more" element={<More data-id="element-15" />} data-id="element-14" />
            <Route path="/maintenance" element={<Maintenance data-id="element-17" />} data-id="element-16" />
            <Route path="/weather" element={<Weather data-id="element-19" />} data-id="element-18" />
            <Route path="/map" element={<Map data-id="element-21" />} data-id="element-20" />
            <Route path="/contact" element={<Contact data-id="element-23" />} data-id="element-22" />
            <Route path="/feedback" element={<Feedback data-id="element-25" />} data-id="element-24" />
          </Routes>
        </div>
        <nav className="fixed bottom-0 w-full bg-white border-t border-gray-200 flex justify-around items-center h-16 px-2" data-id="element-26">
          <NavLink to="/" icon={<HomeIcon size={24} data-id="element-28" />} label="Home" data-id="element-27" />
          <NavLink to="/bookings" icon={<BookmarkIcon size={24} data-id="element-30" />} label="Boekingen" data-id="element-29" />
          <NavLink to="/activities" icon={<CalendarIcon size={24} data-id="element-32" />} label="Activiteiten" data-id="element-31" />
          <NavLink to="/assistant" icon={<MessageCircleIcon size={24} data-id="element-34" />} label="Assistent" data-id="element-33" />
          <NavLink to="/more" icon={<MoreHorizontalIcon size={24} data-id="element-36" />} label="Meer" data-id="element-35" />
        </nav>
      </div>
    </Router>;
}
const NavLink = ({
  to,
  icon,
  label
}) => {
  return <Link to={to} className="flex flex-col items-center justify-center w-full py-1" data-id="element-37">
      <div className="text-gray-600" data-id="element-38">{icon}</div>
      <span className="text-xs mt-1 text-gray-600" data-id="element-39">{label}</span>
    </Link>;
};